const US_STANDARD_TIME_UTC = [
  {
    utc: 'UTC-5',
    name: 'EST',
  },
  {
    utc: 'UTC-6',
    name: 'CST',
  },
  {
    utc: 'UTC-7',
    name: 'MST',
  },
  {
    utc: 'UTC-8',
    name: 'PST',
  },
  {
    utc: 'UTC-9',
    name: 'AKST',
  },
  {
    utc: 'UTC-10',
    name: 'HAST',
  },
];

const US_DAYLIGHT_SAVING_TIME_UTC = [
  {
    utc: 'UTC-4',
    name: 'EDT',
  },
  {
    utc: 'UTC-5',
    name: 'CDT',
  },
  {
    utc: 'UTC-6',
    name: 'MDT',
  },
  {
    utc: 'UTC-7',
    name: 'PDT',
  },
  {
    utc: 'UTC-8',
    name: 'AKDT',
  },
  {
    utc: 'UTC-9',
    name: 'HADT',
  },
];

export { US_STANDARD_TIME_UTC, US_DAYLIGHT_SAVING_TIME_UTC };
